module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "svg-sprite-a2aa2e5b3e3b70ea2fa34e79b698feaf.svg#facebook",
      toString: function () {
        return this.url;
      }
    }